import { render } from "./aboutUs.vue?vue&type=template&id=4fab9ae2&ts=true"
import script from "./aboutUs.vue?vue&type=script&lang=ts"
export * from "./aboutUs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__